type UnauthorizedHandler = () => void | Promise<void>

let registeredHandler: UnauthorizedHandler | null = null

/**
 * The shell's auth provider registers here so a 401 anywhere in the app reaches
 * one place.
 *
 * Legacy achieved this by monkey-patching `window.fetch`; AGOS does not need to,
 * because every request already goes through `customFetch` (§6). The observable
 * behavior is the same, including which paths are exempt.
 */
export function registerUnauthorizedHandler(handler: UnauthorizedHandler): void {
  registeredHandler = handler
}

export function clearUnauthorizedHandler(): void {
  registeredHandler = null
}

export function notifyUnauthorized(): void {
  void registeredHandler?.()
}
